import { Injectable, signal } from '@angular/core';

/** Hält fest, ob das Backend gerade nur vorübergehend nicht erreichbar ist; Quelle für das globale Banner. */
@Injectable({ providedIn: 'root' })
export class ConnectivityService {
  private readonly unavailableState = signal(false);
  readonly unavailable = this.unavailableState.asReadonly();
  private issuedRequests = 0;
  private issuedAtLastFailure = 0;

  /** Laufende Nummer einer Anfrage, damit ein späterer Erfolg ihrem Absendezeitpunkt zugeordnet werden kann. */
  registerRequest(): number {
    this.issuedRequests += 1;
    return this.issuedRequests;
  }

  setUnavailable(): void {
    this.issuedAtLastFailure = this.issuedRequests;
    this.unavailableState.set(true);
  }

  /**
   * Nur eine Anfrage, die nach dem letzten gemeldeten Ausfall abgeschickt wurde, beweist, dass der
   * Server wieder antwortet. Eine parallele, ältere Antwort ließe das Banner sonst flackern.
   */
  setAvailable(requestTicket: number): void {
    if (requestTicket > this.issuedAtLastFailure) {
      this.unavailableState.set(false);
    }
  }
}
